import { render, staticRenderFns } from "./clinics.vue?vue&type=template&id=48aeecc6&scoped=true&"
import script from "./clinics.vue?vue&type=script&lang=js&"
export * from "./clinics.vue?vue&type=script&lang=js&"
import style0 from "./clinics.vue?vue&type=style&index=0&id=48aeecc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aeecc6",
  null
  
)

export default component.exports